import { APIMapperVariable } from 'services/api/wordEmbedding/types';

const extendMappersWithScoreByOpenRate = (projectModelId: string, mappers: APIMapperVariable[]) => {
  return [...mappers, { id: projectModelId, name: 'success', variable: 'openrate' }];
};

export default extendMappersWithScoreByOpenRate;
